import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const qualifiedOuterBoxStyle = () => ({
  width: '100%',
  paddingTop: '56px',
  overflowX: 'hidden'
});

const TitleStyle = ({ theme }) => ({
  marginBottom: '12px',
  [theme.breakpoints.up('md')]: {
    marginBottom: '16px'
  }
});

const WrapperStyle = ({ theme }) => ({
  width: '100%',

  gridColumn: '1 / span 4',

  [theme.breakpoints.up('sm')]: {
    gridColumn: '2 / span 4'
  },

  [theme.breakpoints.up('md')]: {
    gridColumn: '6 / span 8'
  }
});

const ChaseOfferBoxStyle = ({ theme }) => ({
  backgroundColor: theme.palette.fixed.black,
  padding: '30px',
  borderRadius: '20px',
  marginTop: '40px'
});

const ChaseOfferLinkBoxStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.light,
  padding: '34px 19px',
  borderRadius: '15px',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  textDecoration: 'none'
});

export const QualifiedOuterBoxStyled = styled(Box)(qualifiedOuterBoxStyle);
export const HeadingStyled = styled(Heading)(TitleStyle);
export const Wrapper = styled(Stack)(WrapperStyle);
export const ChaseOfferBoxStyled = styled(Stack)(ChaseOfferBoxStyle);
export const ChaseOfferLinkBoxStyled = styled(Link)(ChaseOfferLinkBoxStyle);
